import { Col, Row, Select } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { AgentLoanApplicationMerchantSnapshotBusinessInfo } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationMerchantSnapshotBusinessInfo';
import { AgentLoanApplicationMerchantSnapshotGeneralInfo } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationMerchantSnapshotGeneralInfo';
import { AgentLoanApplicationMerchantSnapshotSales } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationMerchantSnapshotSales';
import { AgentLoanApplicationsStore } from 'src/stores/AgentLoanApplicationsStore/AgentLoanApplicationsStore';
import { DateHelper } from 'src/utils/DateHelper';
import styled from 'styled-components';

export const AgentLoanApplicationMerchantSnapshotTab = observer(() => {
    const [selectedSnapshotId, setSelectedSnapshotId] = useState<string | null>(
        null,
    );
    const snapshots = AgentLoanApplicationsStore.merchantSnapshots || [];
    const {
        params: { id },
    } = useRouteMatch<{ id: string }>();

    useEffect(() => {
        AgentLoanApplicationsStore.loadCheckPenaltyData(id);
    }, [id]);

    const snapshotOptions = useMemo(() => {
        return snapshots.map((snapshot) => {
            const dateValue = snapshot.createdAt;
            const formattedDate = dateValue
                ? DateHelper.formatDate(dateValue)
                : '';

            return {
                value: dateValue || '',
                label: formattedDate,
            };
        });
    }, [snapshots]);

    const selectedSnapshot = useMemo(() => {
        if (!selectedSnapshotId && snapshots.length > 0) {
            const first = snapshots[0];
            if (first.createdAt) {
                setSelectedSnapshotId(first.createdAt);
            }

            return first;
        }

        return snapshots.find(
            (snapshot) => snapshot.createdAt === selectedSnapshotId,
        );
    }, [snapshots, selectedSnapshotId]);

    const hasSnapshots = snapshots.length > 0;

    return (
        <Row gutter={[16, 16]} align="middle">
            {hasSnapshots && (
                <>
                    <Col xs={4}>
                        {t(
                            'Agent.LoanApplication.MerchantSnapshot.SnapshotDate',
                        )}
                        :
                    </Col>
                    <Col xs={4}>
                        <StyledSelect
                            value={selectedSnapshotId}
                            onChange={setSelectedSnapshotId}
                            options={snapshotOptions}
                        />
                    </Col>
                </>
            )}

            <Col xs={24}>
                {selectedSnapshot && (
                    <>
                        <AgentLoanApplicationMerchantSnapshotGeneralInfo
                            snapshot={selectedSnapshot}
                        />
                        <AgentLoanApplicationMerchantSnapshotBusinessInfo
                            snapshot={selectedSnapshot}
                        />
                        <AgentLoanApplicationMerchantSnapshotSales
                            snapshot={selectedSnapshot}
                        />
                    </>
                )}
            </Col>
        </Row>
    );
});

const StyledSelect = styled<any>(Select)`
    min-width: 100px;
`;
